import styled from 'styled-components';

import AssignmentSection from './component';

export default styled(AssignmentSection)`
  background-color: #4e667e;
  display: flex;

  .toolbar {
    color: #fff;
    background-color: var(--grey900);
    width: 40px;
    &__item {
      color: #fff;
      width: 40px;
      height: 40px;
      background-color: var(--grey900);
      border: 0;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        pointer-events: none;
        & path {
          fill: var(--grey500) !important;
        }
      }
      -webkit-appearance: none;
      &.selected {
        background-color: #4e667e;
        svg {
          & path {
            fill: #fff !important;
          }
        }
      }
    }
  }

  .header-date {
    background-color: var(--grey800);
    padding: 0 1.6rem;
    height: 32px;
    color: #fff;
    display: flex;
    align-items: center;
    font-weight: bold;
  }

  .content {
    flex: 1;
    min-width: 382px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
  }

  .title {
    color: #fff;
    padding: 1.4rem 1.6rem;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 1.4rem;
  }

  .assign-button {
    background-color: var(--primary100);
    border: 1px solid var(--primary300);
    color: var(--primary500);
    border-radius: 2px;
    height: 36px;
    width: 100%;
    cursor: pointer;
    -webkit-appearance: none;
  }
`;
